module.exports = __webpack_public_path__ + "static/media/icon-filter-active.0115a1a0.svg";